<div class="window-modal-preferences window-modal" [ngClass]="{web:ui===0, desktop:ui===1, mobile:ui!==0&&ui!==1, phone:ui===2||ui===4, oai:isAddin}" (keyup.enter)="rightHdrBtnClick()" (keyup.escape)="cancelHdrBtnClick()">
  @if (ui!==2 && ui!==4) {
    <edx-window-modal-header [title]="getName()" [desc]="desc" [rightBtn]="showSave?saveStr:showReset?resetStr:null" [showCancel]="showSave" (rightHdrBtnClick)="rightHdrBtnClick()" (cancelHdrBtnClick)="cancelHdrBtnClick()"></edx-window-modal-header>
  }
  @if (!showSpinner) {
    <div class="tabcontainer">
      <edx-tab-selector #tabSelector [receiver]="this" [tabdefs]="tabList" [disable]="showSave"></edx-tab-selector>
    </div>
    <div class="contentpanel" tabindex="0">
      @switch (tabId) {
        @case ('general') {
          <div class="formcontainer">
            <edx-form-wrapper #formWrapper [kind]="'__local_preferences_general'" [desc]="desc" [formDialog]="this" (okEnabled)="okEnabled($event)"></edx-form-wrapper>
          </div>
        }
        @case ('libraries') {
          <div>
            <div class="loginlibchooser">
              <label for="loginchoosersel">{{forLoginLibStr}}</label>
              <edx-select [id]="'loginchoosersel'" name="loginchoosersel" [ariaLabel]="forLoginLibStr" [items]="loginLibSelItems" [value]="primaryLib" (change)="logInlibChanged($event)"></edx-select>
              <div class="note">{{resetNote}}</div>
            </div>
            <div class="liblistcontainer">
              @if (ui<2) {
                <edx-list-table [schemaId]="'LIBRARY_MATRIX'" [parent]="this" [desc]="desc" [hasFootprint]="true"></edx-list-table>
              }
              @if (ui>=2) {
                <edx-list-mobile [schemaId]="'LIBRARY_MATRIX'" [parent]="this" [desc]="desc" [hasFootprint]="true" [schemaLayout]="true"></edx-list-mobile>
              }
            </div>
          </div>
        }
        @case ('tiles') {
          <div class="formcontainer">
            <div class="resetwrapper">
              <label for="reset_tiles">{{forPrimaryStr}}</label>
            </div>
            <edx-form-wrapper #formWrapper [kind]="'__local_preferences_tiles'" [desc]="desc" [formDialog]="this" (okEnabled)="okEnabled($event)"></edx-form-wrapper>
          </div>
        }
        @case ('profile_defaults') {
          <div class="listcontainer">
            @if (ui===2 || ui===4) {
              <div class="selwrapper">
                <edx-select [id]="'edx_libsel_item'" [items]="libSelItems" [value]="!!desc?desc.lib:''" (change)="libChanged($event)"></edx-select>
                <edx-select [id]="'edx_appidsel_item'" [items]="appIDSelItems" [value]="curAppID" (change)="appIDChanged($event)"></edx-select>
              </div>
              <div class="listwrapper">
                <edx-list-mobile [schemaId]="'APP_ID_FORMS'" [parent]="this" [desc]="desc" [schemaLayout]="true" [inlineActionMenuId]="6" [inlineActionTarget]="this"></edx-list-mobile>
              </div>
            }
            @if (ui!==2 && ui!==4) {
              <div class="left">
                <div class="selwrapper">
                  <div class="sellabel">{{forLibStr}}</div>
                  <edx-select [id]="'edx_libsel_item'" [ariaLabel]="forLibStr" [items]="libSelItems" [value]="!!desc?desc.lib:''" (change)="libChanged($event)"></edx-select>
                </div>
                <edx-filelist-sidebar [receiver]="this" [list]="appIDItems" [selectIndex]="curAppIDIndex" [desc]="desc" [disabled]="disabledNav" [tabIndex]="0"></edx-filelist-sidebar>
              </div>
              <div class="right">
                @if (ui<2) {
                  <edx-list-table #profileDefaultsTable [schemaId]="'APP_ID_FORMS'" [parent]="this" [desc]="desc" [inlineActionMenuId]="6" [inlineActionTarget]="this"></edx-list-table>
                }
                @if (ui>=2) {
                  <edx-list-mobile [schemaId]="'APP_ID_FORMS'" [parent]="this" [desc]="desc" [schemaLayout]="true" [inlineActionMenuId]="6" [inlineActionTarget]="this"></edx-list-mobile>
                  @if (cbChecked) {
                    <edx-action-bar [menuID]="6" [target]="this" id="edx_list_action_menu"></edx-action-bar>
                  }
                }
              </div>
            }
          </div>
        }
      }
    </div>
  }
  @if (showSpinner) {
    <edx-spinner></edx-spinner>
  }
</div>
